import { render, staticRenderFns } from "./realNameAuth.vue?vue&type=template&id=5073cdcf&"
import script from "./realNameAuth.vue?vue&type=script&lang=js&"
export * from "./realNameAuth.vue?vue&type=script&lang=js&"
import style0 from "./realNameAuth.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\admin\\datacenter_web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5073cdcf')) {
      api.createRecord('5073cdcf', component.options)
    } else {
      api.reload('5073cdcf', component.options)
    }
    module.hot.accept("./realNameAuth.vue?vue&type=template&id=5073cdcf&", function () {
      api.rerender('5073cdcf', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/loginconfig/realNameAuth.vue"
export default component.exports